module.exports = __webpack_public_path__ + "img/8.6384a9fe.webp";